import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "report" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<header><div class=\"row\"><div class=\"col-sm-6\"><h1>System Admin</h1></div><div class=\"col-sm-6 text-right\"><button class=\"btn btn-light\" data-toggle=\"modal\" data-target=\"#add-newuser-modal\" title=\"Add User\"><i class=\"fas fa-plus\"></i> New User </button></div></div></header>", 1)
const _hoisted_3 = {
  class: "nav nav-tabs mb-3",
  role: "tablist"
}
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = { class: "nav-item" }

import { onMounted }  from 'vue';
import { useStore } from 'vuex';

import NewUserModal from "@/components/modals/NewUserModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SysAdmin',
  setup(__props) {

const store = useStore();

const getGroups = () => {
  store.dispatch('sysadmin/getGroups');
};

onMounted(async () => {
  getGroups();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", _hoisted_4, [
        _createVNode(_component_router_link, {
          to: "/sysadmin/userlist",
          class: "nav-link",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Users ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: "/sysadmin/grouplist",
          class: "nav-link",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Groups ")
          ]),
          _: 1
        })
      ])
    ]),
    (_openBlock(), _createBlock(_component_router_view, {
      key: _ctx.$route.name
    })),
    _createVNode(NewUserModal)
  ]))
}
}

})